import { createDCHook } from '../client';
import { siteRoot } from '../services/HealthService';

export const useHealthSiteRoot = createDCHook('siteRoot', siteRoot, { injectables: [], flattenData: false });
